import { t, useLanguage } from '../i18n';
import React from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { Button, Card, useTheme } from 'react-native-paper';
import { Ionicons } from '@expo/vector-icons';

type GateUnavailableOverlayProps = {
  visible: boolean;
  loading: boolean;
  onRetry: () => void;
  onGoToRecovery: () => void;
  bottomOffset?: number;
};

const GateUnavailableOverlay: React.FC<GateUnavailableOverlayProps> = ({
  visible,
  loading,
  onRetry,
  onGoToRecovery,
  bottomOffset = 0,
}) => {
  useLanguage();
  const theme = useTheme();
  if (!visible) return null;

  return (
    <View style={[styles.backdrop, { bottom: bottomOffset }]}>
      <Card style={[styles.modalContent, { backgroundColor: theme.colors.surface }]}>
        <View style={styles.container}>
          {loading ? (
            <ActivityIndicator size="large" color={theme.colors.primary} />
          ) : (
            <Ionicons name="cloud-offline" size={64} color={theme.colors.error} />
          )}
          <Text style={[styles.title, { color: theme.colors.onSurface }]}>
            {loading ? t("利用状況を確認しています") : t("利用状況を確認できません")}
          </Text>
          <Text style={[styles.description, { color: theme.colors.onSurfaceVariant }]}>
            {loading
              ? t("確認が完了するまで、この機能は一時的に利用できません。")
              : t("通信状況を確認して、もう一度お試しください。確認できるまでは制限対象の機能を利用できません。")}
          </Text>
          {!loading ? (
            <>
              <Button mode="contained" onPress={onGoToRecovery} style={styles.button}>
                {t("履修検索を開く")}
              </Button>
              <Button mode="outlined" onPress={onRetry} style={styles.retryButton}>
                {t("再試行")}
              </Button>
            </>
          ) : null}
        </View>
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    justifyContent: 'center',
    zIndex: 1001,
  },
  modalContent: {
    margin: 24,
    borderRadius: 24,
    overflow: 'hidden',
  },
  container: {
    padding: 24,
    alignItems: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: 16,
    marginBottom: 12,
  },
  description: {
    fontSize: 15,
    textAlign: 'center',
    lineHeight: 22,
  },
  button: {
    width: '100%',
    marginTop: 20,
    borderRadius: 12,
  },
  retryButton: {
    width: '100%',
    marginTop: 12,
    borderRadius: 12,
  },
});

export default GateUnavailableOverlay;
